<!-- @format -->

<sis-description-list-compact [columnCount]="1">
  <dl>
    <ng-template #compactListItem>
      <dt data-cy="course-unit-info-modal-placement" class="label colon">{{ "COURSE_UNIT_INFO_MODAL.PLACED" | translate }}</dt>
      @if (planLocation) {
        <dd class="value">
          {{ planLocation | localizedString }}
        </dd>
      } @else {
        <dd class="value">
          {{ "COURSE_UNIT_INFO_MODAL.NOT_PLACED" | translate }}
        </dd>
      }
    </ng-template>

    <ng-template #compactListItem>
      <dt data-cy="course-unit-info-modal-status" class="label colon">{{ "COURSE_UNIT_INFO_MODAL.STATUS" | translate }}</dt>
      @if (courseUnitAttainment) {
        <dd class="value">
          {{ courseUnitAttainment.state | attainmentStatusTranslation | translate }}
          @if (courseUnitAttainment.credits) {
            <span>({{ courseUnitAttainment.credits | decimalNumber }} {{ "CREDITS" | translate }})</span>
          }
        </dd>
      } @else {
        <dd class="value">
          {{ "COURSE_UNIT_INFO_MODAL.NOT_ATTAINED" | translate }}
        </dd>
      }
    </ng-template>

    <ng-template #compactListItem>
      <dt data-cy="course-unit-info-modal-grade" class="label colon">{{ "FIELD_NAMES.grade" | translate }}</dt>
      @if (courseUnitAttainment) {
        <dd class="value">
          {{ courseUnitAttainment.gradeId | grade: courseUnitAttainment.gradeScaleId : "NAME" | async }}
        </dd>
      } @else {
        <dd class="value">
          {{ "COURSE_UNIT_INFO_MODAL.NOT_GRADED" | translate }}
        </dd>
      }
    </ng-template>
  </dl>
</sis-description-list-compact>
